
import React from 'react';
import BeltIcon from './belt-icon';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface BeltDisplayProps {
  belts: string;
  className?: string;
}

const BeltDisplay: React.FC<BeltDisplayProps> = ({ belts, className }) => {
  const isMobile = useIsMobile();
  
  // Parse the belt string into an array
  const beltArray = belts.split(',').map(belt => belt.trim());
  
  // Create an array of all possible belt positions (11 total)
  // This ensures consistent alignment across all cards
  const beltSlots = Array(11).fill(null);
  
  // Map belt names to their appropriate types
  const displayBelts = beltArray.map(belt => {
    // Handle special cases and standardize belt names
    if (belt.includes('White')) return 'white';
    if (belt.includes('Yellow')) return 'yellow';
    if (belt.includes('Orange')) return 'orange';
    if (belt.includes('Light Blue')) return 'light-blue';
    if (belt.includes('Green')) return 'green';
    if (belt.includes('Purple')) return 'purple';
    if (belt.includes('Brown')) return 'brown';
    if (belt.includes('Red')) return 'red';
    if (belt.includes('Navy')) return 'navy';
    if (belt.includes('Grey')) return 'grey';
    if (belt === 'Black') return 'black';
    if (belt.includes('Black') && belt.includes('White')) return 'black-white';
    if (belt === 'Dragon') return 'dragon';
    if (belt.includes('weapon')) return 'weapon';
    return 'white'; // Default
  });

  const iconSize = isMobile ? 25 : 30;

  return (
    <div className={cn("flex items-center gap-1 md:gap-2 flex-wrap", className)}>
      {beltSlots.map((_, index) => {
        const beltType = index < displayBelts.length ? displayBelts[index] : null;
        return (
          <div key={index} className={`w-[${iconSize}px] flex justify-center`}>
            {beltType ? <BeltIcon type={beltType as any} responsive={true} /> : <div className={`w-[${iconSize}px] h-[${iconSize}px] opacity-0`} />}
          </div>
        );
      })}
    </div>
  );
};

export default BeltDisplay;
